"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.default = mergeStyles;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Merges multiple className objects into one by concatenating
 * multiple localized classes with the same global name into one.
 */
function mergeStyles() {
  for (var _len = arguments.length, themes = Array(_len), _key = 0; _key < _len; _key++) {
    themes[_key] = arguments[_key];
  }

  return themes.reduce(function (acc, theme) {
    var classList = (0, _keys2.default)(theme);

    classList.forEach(function (className) {
      var localName = theme[className];

      // check if this className is already in the merge
      if (acc[className]) {
        // if the local className does not exist in the merge scope yet add it
        if (acc[className].indexOf(localName) <= -1) {
          acc[className] = acc[className] + " " + localName; // eslint-disable-line
        }
      } else {
        acc[className] = localName; // eslint-disable-line
      }
    });

    return acc;
  }, {});
}